export { default as AddPatients } from "./AddPatients/AddPatients";

export { default as PatientTable } from "./PatientTable";
export { default as PatientDetailsCard } from "./PatientDetailsCard";
export { default as ProgressCard } from "./ProgressCard";
export { default as TimelineCard } from "./TimelineCard";
export { default as EventsCard } from "./EventsCard";
export { default as RoomStatistics } from "./RoomStatistics";
export { default as TreatmentHistoryCard } from "./TreatmentHistoryCard";
